import React, { useState, useContext, useRef, useMemo } from 'react'
import styled, { css, ThemeContext } from 'styled-components'
import { Flex, Box } from 'reflexbox/styled-components'
import { Link } from 'react-router-dom'

import ChevronDownIcon from 'components/Icons/ChevronDown'
import ChevronUpIcon from 'components/Icons/ChevronUp'
import MenuButton from 'components/MenuButton'

import { useAuth } from 'context/auth-context'
import { useUser } from 'context/user-context'
import { useNavbar } from 'context/navbar-context'
import useOnClickOutside from 'hooks/useOnClickOutside'

const Topbar = ({ showSidebar, updateSidebar }) => {
  const [isMenuOpen, setMenuOpen] = useState(false)
  const { isNavbarOpenOnMobile, setIsNavbarOpenOnMobile } = useNavbar()
  const { logout } = useAuth()
  const { user } = useUser()
  const theme = useContext(ThemeContext)
  const accountMenuRef = useRef()

  const username = useMemo(() => {
    return user.company_name ? user.company_name : user.first_name
  }, [user])

  useOnClickOutside(accountMenuRef, () => {
    updateSidebar(false)
  })

  return (
    <Container alignItems='center'>
      <MenuButton
        handleClick={() => {
          updateSidebar()
          setIsNavbarOpenOnMobile(!isNavbarOpenOnMobile)
        }}
        color={theme.colors.white}
        display={['initial', 'initial', 'initial']}
      />

      <ButtonsContainer>
        <Account ref={accountMenuRef}>
          <Button onClick={() => setMenuOpen(!isMenuOpen)}>
            <Username>{username}</Username>
            {isMenuOpen ? <ChevronUpIcon color={theme.colors.white} /> : <ChevronDownIcon color={theme.colors.white} />}
          </Button>

          <Menu open={isMenuOpen}>
            <MenuItem
              as={Link}
              onClick={() => setMenuOpen(false)}
              to={user.company_name ? '/settings' : '/staff/settings'}
            >
              Configurações
            </MenuItem>
            <MenuItem as='button' onClick={logout}>
              Sair
            </MenuItem>
          </Menu>
        </Account>
      </ButtonsContainer>
    </Container>
  )
}

const Container = styled(Flex)`
  height: 80px;
`

Container.defaultProps = {
  bg: 'blues.A900',
  justifyContent: ['space-between', 'space-between', 'between-end'],
  px: '24px',
}

const ButtonsContainer = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: row;
`

const Account = styled(Flex)`
  position: relative;
`

const Button = styled.button`
  display: flex;
  align-items: center;
  cursor: pointer;
  border: none;
  background: none;

  color: ${({ theme }) => theme.colors.white};
  font-size: 16px;
  font-weight: 800;
  font-family: ${({ theme }) => theme.fonts.body};
  outline: none;
`

const Username = styled.span``

const Menu = styled(Box)(
  ({ open, theme }) => css`
    display: ${open ? 'block' : 'none'};
    position: absolute;
    top: 100%;
    right: 0;
    width: auto;
    z-index: 10;
    a,
    button {
      display: block;
      min-width: 200px;
      text-decoration: none;
      border: none;
      text-align: left;
      background-color: transparent;
      color: ${theme.colors.text};
      font-size: ${theme.fontSizes.body};
      line-height: 2;
      cursor: pointer;

      :hover {
        text-decoration: underline;
      }
    }
  `,
)

Menu.defaultProps = {
  sx: {
    bg: 'white',
    boxShadow: 'under.1',
  },
  p: '24px',
}

const MenuItem = styled.li``

export default Topbar
